
/**
 *@property {string} Id
 *@property {string} UpdatedUserId
 *@property {string} CreatedUserId
 *@property {string} CreatedAt
 *@property {string} UpdateAt
 */
export class BaseModel {

    watch(setKey, key, func = null) {
        if (typeof func == 'function') {
            Object.defineProperty(this, setKey, {
                set: (value) => {
                    const tmp = func(value)
                    this[key] = tmp || 0
                },
                get: () => this[key],
                configurable: true,
                enumerable: true
            })
        } else if (func === null) {
            Object.defineProperty(this, setKey, {
                set: (value) => {
                    this[key] = value
                },
                get: () => this[key],
                configurable: true,
                enumerable: true
            })
        }
    }
    change(owner = {}) {
        owner = owner || {}
        const keys = Object.keys(owner)
        for (const key of keys) {
            if (owner[key]) {
                this[key] = owner[key]
            }
        }
        return this
    }

    removeKeys(fields) {
        for (const key of fields) {
            delete this[key]
        }
        return this
    }

    /**
     *
     * @returns {this}
     */
    copy() {
        return Object.assign(this, {...this})
    }

    newOwner() {
        const objects = this.fields.filter((value) => typeof value === 'object')

        for (const object of objects) {
            const keys = Object.keys(object)
            keys.map(key => {
                const isArray = Array.isArray(object[key])
                const realField = key.replace('set', '')
                if (isArray) {
                    this[realField] = []
                } else if (object[key] instanceof BaseModel) {
                    this[realField] = object[key].copy()
                } else {
                    this.watch(key, realField, object[key])
                }
            })
        }

        for (const field of this.fields) {
            if (typeof field !== 'object') {
                const realField = field.replace('set', '')
                this.watch(field, realField)
            }
        }

        return this
    }


    testNew() {
        // value : type
    }

    fields = [
        'setId',
        'setUpdatedUserId',
        'setCreatedUserId',
        'setCreatedAt',
        'setUpdateAt'
    ]

    /**
     * @param {BaseModel | {}} owner
     * @param {Array} fields
     */
    constructor(owner, fields) {
        owner = owner || {}
        this.fields = fields.concat(this.fields)
        this.newOwner()
    }

}